//import './swiper.min.js';

function setCookie(c_name, value, exsecs) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate());
	exdate.setSeconds(exdate.getSeconds() + exsecs);
	var c_value = escape(value) + ((exsecs == null) ? "" : "; expires=" + exdate.toUTCString());
	document.cookie = c_name + "=" + c_value + ";path=/";
}
function getCookie(c_name) {
	var i, x, y, ARRcookies = document.cookie.split(";");
	for (i = 0; i < ARRcookies.length; i++) {
		x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
		x = x.replace(/^\s+|\s+$/g, "");
		if (x == c_name) {
			return unescape(y);
		}
	}
}

jQuery(document).ready(function() {

	// Language selector
	jQuery('.lang_selector .curr').click( function() {
		jQuery(this).closest('.lang_selector').find('ul').slideToggle();
	});
	jQuery('.lang_selector li').click( function() {
        var lang = jQuery(this).data('lang');
        var href = jQuery('.wpml-ls .wpml-ls-native[lang='+lang+']').parent().attr('href');
		window.location.href = href;
	});

	// sign up popup
	// jQuery('.sign_up_pop__close, .pop_bg').click( function() {
	// 	if(jQuery(this).closest('.pop_cont').hasClass('.pop_cont--sign_up')) {
	// 		setCookie('sign_up_popup', 'true', 86400);
	// 	}
	// 	jQuery(this).closest('.pop_cont').removeClass('open');
	// 	jQuery('body').removeClass('lock_scroll');
	// });
	// confirm_cookie = getCookie('sign_up_popup');
	// if(confirm_cookie == null && !jQuery('body').hasClass('logged-in') && !jQuery('body').hasClass('single-product')) {
	// 	setTimeout( function() {
	// 		jQuery('.pop_cont--sign_up').addClass('open');
	// 		jQuery('body').addClass('lock_scroll');
	// 	}, 4000);
	// }

	// // request a quote button
	// jQuery('.rq_quote').click( function() {
	// 	jQuery('.pop_cont--rq').addClass('open');
	// 	jQuery('body').addClass('lock_scroll');

	// 	jQuery('.pop_cont--rs input[name="product-code"]').val(jQuery('.product_title.entry-title').text());
	// });

	// // request a sample button
	// jQuery('.custom_btns__btn--sample').click( function() {
	// 	jQuery('.pop_cont--rs').addClass('open');
	// 	jQuery('body').addClass('lock_scroll');

	// 	jQuery('.pop_cont--rs input[name="product"]').val(jQuery('.product_title.entry-title').text());
	// });

	var width = jQuery(window).width();

	// shop info mobile slider
	var shop_info_slider = new Swiper('.shop_info .swiper-container', {
		speed: 300,
		loop: false,
		slidesPerView: 3,
		spaceBetween: 20,
		allowTouchMove: false,
		breakpoints: {
			800: {
				slidesPerView: 2,
				//allowTouchMove: true,
			},
			600: {
				slidesPerView: 1,
				spaceBetween: 10,
				centeredSlides: true,
				loop: true,
				//allowTouchMove: true,
			}
		}
	});
	jQuery('.shop_info__page__bullet').click( function() {
		var index = jQuery(this).attr('data-index');
		shop_info_slider.slideTo(index, 300, true);
		jQuery('.shop_info__page__bullet').removeClass('active');
		jQuery(this).addClass('active');
		console.log('slide changed bullet');
	});
	shop_info_slider.on('slideChange', function () {
		console.log('slide changed slide');
		var index = shop_info_slider.activeIndex;
		jQuery('.shop_info__page__bullet').removeClass('active');
		var activeBullet = '.shop_info__page__bullet[data-index='+index+']';
		jQuery(activeBullet).addClass('active');
	});

	jQuery('.nav-item--back a').click(function (e) {
		e.preventDefault();
		jQuery(this).closest('.flyout_menu__sub_menu').removeClass('open');
	});

	jQuery('.nav-item--is_parent > a').click(function (e) {
		e.preventDefault();
		jQuery(this).parent().toggleClass('open');
	});

	var latest_posts = new Swiper('.latest_posts__slider.swiper-container', {
		speed: 300,
		loop: false,
		slidesPerView: 3,
		autoHeight: true,
		spaceBetween: 20,
		allowTouchMove: false,
		breakpoints: {
			700: {
				slidesPerView: 1,
				//allowTouchMove: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			}
		}
	});

	// USPs slider
	var usps = new Swiper('.usps .swiper-container', {
		speed: 300,
		loop: true,
		slidesPerView: 3,
		allowTouchMove: false,
		spaceBetween: 0,
		loop: false,
		
		breakpoints: {
			600: {
				slidesPerView: 1,
				allowTouchMove: true,
				autoplay: {
					delay: 5000,
				},
			}
		}
	});
    
    // home slider
    var home_slider = new Swiper('.home_slider.swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
		  nextEl: '.home_slider .swiper-button-next',
		  prevEl: '.home_slider .swiper-button-prev',
		},
	});

    // featured product slider
	var feat_prod_slider = new Swiper('.feat_slider__slider--prods.swiper-container', {
		speed: 300,
		loop: false,
		slidesPerView: 6,
		slidesPerGroup: 6,
		spaceBetween: 24,
		autoplay: false,
		navigation: {
			nextEl: '.feat_slider__slider--prods .swiper-button-next',
			prevEl: '.feat_slider__slider--prods .swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
			600: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 15,
			},
		},
	});

	// featured product slider
	var fave_prod_slider = new Swiper('.feat_slider__slider--favs.swiper-container', {
		speed: 300,
		loop: false,
		slidesPerView: 6,
		slidesPerGroup: 6,
		spaceBetween: 24,
		autoplay: false,
		navigation: {
			nextEl: '.feat_slider__slider--favs .swiper-button-next',
			prevEl: '.feat_slider__slider--favs .swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
			600: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 15,
			},
		},
	});

	// Related product slider
    var feat_prod_slider = new Swiper('.feat_slider__slider--rel.swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 57,
		autoplay: false,
        navigation: {
            nextEl: '.feat_slider__slider--rel .swiper-button-next',
            prevEl: '.feat_slider__slider--rel .swiper-button-prev',
        },
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 24,
			},
			600: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 15,
			},
		},
	});

	// featured category slider
    var feat_cats_slider = new Swiper('.feat_slider__slider--cats.swiper-container', {
		speed: 300,
		loop: false,
		slidesPerView: 4,
		slidesPerGroup: 4,
		spaceBetween: 59,
		autoplay: false,
        navigation: {
            nextEl: '.feat_slider__slider--cats .swiper-button-next',
            prevEl: '.feat_slider__slider--cats .swiper-button-prev',
        },
		breakpoints: {
			800: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 30,
			},
		},
	});
	if(width < 501) {
		// feat_cats_slider.disable();
		if (jQuery('.feat_slider__slider--cats.swiper-container').length > 0){
			feat_cats_slider.destroy(false, true);
		}
	}
	jQuery('.feat_slider .more_cats').click( function() {
		jQuery(this).closest('.feat_slider').find('.cat_slide').addClass('dis');
		jQuery(this).addClass('hide');
	});

	// featured applications slider
    var feat_apps_slider = new Swiper('.feat_slider__slider--apps.swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 40,
		autoplay: {
			delay: 5000,
		},
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
		breakpoints: {
			1000: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 30,
			},
			800: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			600: {
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				spaceBetween: 16,
			},
		},
	});

    // testimonial slider
    var testimonial_slider = new Swiper('.testimonials__slider.swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 1,
		spaceBetween: 34,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
	});

	// home slider
    var alt_content_slider = new Swiper('.alt_content .swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
	});


	
    var about_alt_slider = new Swiper('.ps_alternating__single__image--slider .swiper-container', {
		speed: 300,
		loop: false,
        slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
	});

	jQuery('.ps_doughnut__text .link--popup').click(function (e) {
		e.preventDefault();
		jQuery('.l_box__doughnut').addClass('active');
	});

	jQuery('.l_box__doughnut .close, .l_box__doughnut .bg').click(function () {
		jQuery('.l_box__doughnut').removeClass('active');
	});


	jQuery('.signup_pop__close, .signup_pop__bg').click(function () {
		jQuery('.signup_pop').removeClass('active');
	});

	// view_count = getCookie('page_view');
	// signup_pop = getCookie('signup_pop');
	// if(view_count == null && signup_pop == null) {
	// 	setCookie('page_view', 1, 1);
	// } else if (view_count < 3 && signup_pop == null) {
	// 	view_count++;
	// 	setCookie('page_view', view_count, 3);
	// } else if (signup_pop == null) {
	// 	jQuery('.signup_pop').addClass('active');
	// 	setCookie('page_view', null, 3);
	// 	setCookie('signup_pop', 1, 7);
	// }

	// if (signup_pop == null) {
	// 	var fired = false;
	// } else {
	// 	var fired = true;
	// }

	// jQuery(window).scroll(function() {
	// 	// Get current scroll position
	// 	var scrollPosition = jQuery(window).scrollTop();
		
	// 	// Calculate halfway point (total document height minus viewport height, divided by 2)
	// 	var halfwayPoint = (jQuery(document).height() - jQuery(window).height()) / 2;
		
	// 	// Check if we've scrolled past halfway and haven't fired the action yet
	// 	if (scrollPosition > halfwayPoint && !fired) {
	// 		// Your action here
	// 		jQuery('.signup_pop').addClass('active');
	// 		setCookie('page_view', null, 3);
	// 		setCookie('signup_pop', 1, 7);
			
	// 		// Set fired to true so it only happens once
	// 		fired = true;
	// 	}
	// });


	jQuery('.filter_categories_mobile select').on('change', function () {
		var selected = jQuery('option[selected]').val();
		console.log(selected);
		location.replace(selected);
	});


	// product show option
	function setCookie(c_name, value, exdays) {
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
		document.cookie = c_name + "=" + c_value + ";path=/";
	}
	jQuery('select.show_prods.choices__input').on('change', function() {
		var show = jQuery(this).val();
		setCookie('num_products_show', show, 3);
		location.reload();
	});


	// product slider
	if(jQuery('.product_thumbs.swiper-container').length > 0) {
		var prodsliderThumbs = new Swiper('.product_thumbs.swiper-container', {
			//width: 90,
			slidesPerView: 4,
			//height: 90,
			spaceBetween: 20,
			watchSlidesProgress: true,
			allowTouchMove: false,
			direction: 'vertical',
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				500: {
					spaceBetween: 12,
					direction: 'horizontal',
					slidesPerView: 'auto',
				}
			}
		});
	}
	jQuery('.product_gallery.swiper-container .woocommerce-product-gallery__image').addClass('swiper-slide');
	var prodslider = new Swiper('.product_gallery.swiper-container', {
		slidesPerView: 1,
		//autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: prodsliderThumbs,
		},
	});


	// Plus/ minus buttons for quantity input
	jQuery('.custom_qty__btn').on('click', function() {

		var button = jQuery(this);
		var oldValue = button.parent().find("input").val();
  
		var addBtn = jQuery(this).closest('form.cart').find(".custom_btns__btn--add_bskt");
  
		var oldURL = addBtn.attr('href');
  
		if (button.hasClass('custom_qty__plus')) {
			var newVal = parseFloat(oldValue) + 1;
  
			addBtn.attr('href', oldURL);
			newURL = oldURL + '&quantity=' + newVal;
			addBtn.attr('href', newURL);
		} else {
			// Don't allow decrementing below zero
		  	if (oldValue > 0) {
				var newVal = parseFloat(oldValue) - 1;
  
				addBtn.attr('href', oldURL);
				newURL = oldURL + '&quantity=' + newVal;
				addBtn.attr('href', newURL);
		  	} else {
				newVal = 0;
	
				addBtn.attr('href', oldURL);
				newURL = oldURL + '&quantity=' + newVal;
				addBtn.attr('href', newURL);
		  	}
		}
  
		button.parent().find("input").val(newVal);
  
	});


	// FAQs
	jQuery('.faqs__faq__head').click( function() {
		jQuery(this).next().slideToggle();
		jQuery(this).find('.faqs__faq__toggle').toggleClass('open');
	});


	// Open category filter options
	jQuery('.cat_filter__head').click( function() {
		jQuery(this).toggleClass('open');
		jQuery(this).next().slideToggle();
	});


	// variation select update add to basket button
	jQuery('.variations .choices__input').on('change', function() {
		var val = jQuery(this).val();
		console.log(val);
	});


	// product tabs
	jQuery('.product_tabs__menu__item').click( function() {
		var id = jQuery(this).attr('data-id');
		if(width > 800) {
			jQuery('.product_tabs__menu__item').removeClass('active');
			jQuery('.product_tabs__tab').removeClass('active');
			jQuery('.product_tabs__tab[data-id="'+id+'"]').addClass('active');
			jQuery(this).addClass('active');
		} else {
			jQuery(this).toggleClass('active');
			jQuery('.product_tabs__tab[data-id="'+id+'"]').slideToggle();
		}
	});


	// custom variations select box
	jQuery('.variations__select').click( function() {
		jQuery(this).find(' > div').slideToggle();
	});
	jQuery('.variations__select > div > div').click( function() {
		jQuery('.variations__select > div > div').removeClass('selected');
		jQuery(this).addClass('selected');
		jQuery('.custom_btns__btn--add_bskt').removeClass('disabled');
		jQuery('.price_and_sku__price .from').remove();
		var text = jQuery(this).text();
		var sku = jQuery(this).attr('data-sku');
		var price = jQuery(this).attr('data-price');
		var value = jQuery(this).attr('data-value');

		var select = jQuery(this).closest('.variations__select');

		select.find('> span').text(text);
		select.attr('data-sku', sku);
		select.attr('data-price', price);
		select.attr('data-value', value);
		jQuery('.price_and_sku__sku span').text(sku);
		jQuery('.price_and_sku__price .price').text(price);
	});

	jQuery('.custom_btns__btn--add_bskt').click( function() {
		if(!jQuery(this).hasClass('disabled')) {
			var curr_url = window.location.href;
			var curr_url = curr_url.split('?');
			var id = jQuery('.variations__select').attr('data-value');
			var qty = jQuery('.custom_qty__qty').val();

			var link = '?add-to-cart='+id+'&quantity='+qty;

			var new_link = curr_url[0] + link;

			window.location.href = new_link;
		}
	});


	// open product video popup
	jQuery('.prod_vid_btn').click( function() {
		jQuery('.prod_vid_pop').addClass('open');
		jQuery('body').addClass('lock_scroll');
	});
	jQuery('.prod_vid_pop figure').click( function() {
		jQuery(this).closest('.prod_vid_pop').removeClass('open');
		jQuery('body').removeClass('lock_scroll');
	});


	// Category filter
	jQuery('.cat_filter__refine__filt').click( function() {
		if(jQuery(this).hasClass('checked')) {
			jQuery(this).removeClass('checked');
		} else {
			jQuery(this).addClass('checked');
		}

		var cats = [];

		jQuery('.cat_filter__refine__filt.cat_filt.checked').each( function() {
			cats.push(jQuery(this).data('value'));
		});

		console.log(cats);

		var filtered = true;
		if(cats.length === 0) {
			filtered == false;
		}

		jQuery('.category_flex__col_2').addClass('loading');

		currenturl = window.location.href;

		jQuery.ajax({
			type: 'GET',
			cache: false,
			url: currenturl,
			data: {
				filtered : filtered,
				cats : cats,
			},
			success: function(response) {
				jQuery('.category_flex__col_2 > .products').html(jQuery('.category_flex__col_2 > .products', response).html());
				jQuery('.category_flex__col_2').removeClass('loading');
			}
		});
	});


	// Price filter
	jQuery('.cat_filter .price_slider_wrapper .button').click( function() {
		if(!jQuery('body').hasClass('search-results')) {
			var min = jQuery('.cat_filter .price_slider_wrapper input#min_price').val();
			var max = jQuery('.cat_filter .price_slider_wrapper input#max_price').val();

			jQuery('.category_flex__col_2').addClass('loading');

			if (min == '') {
				min = 0;
			}

			if (max == '') {
				max = 999999;
			}

			var currenturl = window.location.href;
			var filteredURL = currenturl+'?min_price='+min+'&max_price='+max;

			jQuery.ajax({
				type: 'GET',
				cache: false,
				url: filteredURL,
				success: function(response) {
					jQuery('.category_flex__col_2 > .products').html(jQuery('.category_flex__col_2 > .products', response).html());
					jQuery('.category_flex__col_2').removeClass('loading');

					count_products_for_button_text();
				}
			});
		}
	});
	// View products
	jQuery('.cat_filter_mobile_footer .view_prods').click( function() {
		jQuery('.cat_filter__filt').addClass('filtered');
		jQuery('.filt_submit').trigger('click');
		jQuery('.category_flex__col_1').removeClass('open');
		jQuery('body').removeClass('lock_scroll');
	});
	// Clear filters
	jQuery('.cat_filter_mobile_footer .clear_filts').click( function() {
		jQuery('.cat_filter .price_slider_wrapper input#min_price').val('');
		jQuery('.cat_filter .price_slider_wrapper input#max_price').val('');
	});
	// Onload put product count into button text
	function count_products_for_button_text() {
		var prod_count = jQuery('.category_flex__col_2 .products .prod_slide').length;
		jQuery('.cat_filter_mobile_footer .view_prods > span').text(prod_count);
	}
	count_products_for_button_text();


	// Open mobile flyout menu
	jQuery('.navbar-toggler').click( function() {
		jQuery('.flyout_menu').addClass('show');
		jQuery('body').addClass('lock_scroll');
	});
	jQuery('.flyout_menu__close').click( function() {
		jQuery('.flyout_menu').removeClass('show');
		jQuery('body').removeClass('lock_scroll');
	});
	// Flyout menu sub menus
	jQuery('header .flyout_menu .bar-products > .nav > .nav-item > .nav-link').click( function(e) {
		e.preventDefault();
		console.log('nav link clicked');
		jQuery(this).closest('li.nav-item').find('.flyout_menu__sub_menu').addClass('open');
	});


	// Account Spend stuff
	jQuery('.data-box__menu .active_item').click( function() {
		jQuery(this).closest('.data-box__menu').find('ul').slideToggle();
	});
	jQuery('.data-box__menu').on('mouseleave', function() {
		jQuery(this).closest('.data-box__menu').find('ul').slideUp();
	});
	jQuery('.data-box__menu li').click( function() {
		var text = jQuery(this).text();
		var data_this = jQuery(this).data('this');
		var data_last = jQuery(this).data('last');
		var parent = jQuery(this).closest('.data-box__menu');
		if(data_last !== 0) {
			var per = Math.round(100 * ((data_this - data_last) / data_last));
		} else {
			var per = 0;
		}
		jQuery('.data-box__menu li').removeClass('active');
		jQuery(this).addClass('active');
		parent.find('.active_item').text(text);
		var this_elem = jQuery(this).closest('.data-box__content').find('.data-box__value.this > div');
		this_elem.text(data_this);
		if(per > 0) {
			this_elem.append('<span class="data-box__per data-box__per--up">'+per+'%</span>');
		}
		else if(per < 0) {
			this_elem.append('<span class="data-box__per data-box__per--dwn">'+per+'%</span>');
		}
		else {
			this_elem.append('<span class="data-box__per">0%</span>');
		}
		jQuery(this).closest('.data-box__content').find('.data-box__value.last strong').text(data_last);
		jQuery(this).closest('.data-box__content').find('.data-box__value.last span').text(text);
	});



	// Product single page accordions
	jQuery('.prod_tab__title').click( function() {
		jQuery(this).closest('.prod_tab__head').toggleClass('open');
		jQuery(this).closest('.prod_tab').find('.prod_tab__content').slideToggle();
	});

	// Open / Close all tabs
	jQuery('.prod_tab__all').click( function() {
		var open_tabs = 0;
		jQuery('.prod_tab__head').each( function() {
			if(jQuery(this).hasClass('open')) {
				open_tabs++;
			}
		});
		if(jQuery('.prod_tab__head').length > open_tabs) {
			jQuery('.prod_tab__head').addClass('open');
			jQuery('.prod_tab__content').slideDown();
		} else {
			jQuery('.prod_tab__head').removeClass('open');
			jQuery('.prod_tab__content').slideUp();
		}
	});


	// Menu item hover add class for opacity background
	jQuery('li.nav-item.nav-item--has_sub').on('mouseover', function() {
		jQuery('body > div.wrap').addClass('sub_menu_open');
	});
	jQuery('li.nav-item.nav-item--has_sub').on('mouseleave', function() {
		jQuery('body > div.wrap').removeClass('sub_menu_open');
	});


	// Mobile open filter button
	jQuery('.mobile_filter_btn').click( function() {
		jQuery('.category_flex__col_1').addClass('open');
		jQuery('body').addClass('lock_scroll');
	});
	jQuery('.cat_filter_mobile_head figure').click( function() {
		jQuery(this).closest('.category_flex__col_1').removeClass('open');
		jQuery('body').removeClass('lock_scroll');
	});



	// Request bulk quote and sample popups
	jQuery('.custom_btns__btn--bulk').click( function() {
		jQuery('.pop_cont--rq').addClass('open');
		var url = window.location.href;
		jQuery('.pop_cont--rq .current_page').val(url);
	});
	jQuery('.pop_cont--rq .sign_up_pop__close, .pop_cont--rq .pop_bg').click( function() {
		jQuery('.pop_cont--rq').removeClass('open');
	});

	jQuery('.custom_btns__btn--sample').click( function() {
		jQuery('.pop_cont--rs').addClass('open');
		var url = window.location.href;
		jQuery('.pop_cont--rs .current_page').val(url);
	});
	jQuery('.pop_cont--rs .sign_up_pop__close, .pop_cont--rs .pop_bg').click( function() {
		jQuery('.pop_cont--rs').removeClass('open');
	});

	jQuery('.release_account').click( function() {
		jQuery('.pop_cont--ra').addClass('open');
	});
	jQuery('.pop_cont--ra .sign_up_pop__close, .pop_cont--ra .pop_bg').click( function() {
		jQuery('.pop_cont--ra').removeClass('open');
	});



	// Mobile variable product on change
	jQuery('.prod_var_select__select_prod select.choices__input').on('change', function() {
		console.log('product select input changed');
		var val = jQuery(this).val();
		var sku = '';
		var width = '';
		var height = '';
		var price = '';
		var per_m2 = '';
		var out_of_stock = '';
		// For saved basket
		var var_id = '';
		var prod_id = '';
		jQuery('.prod_table .desccol p').each( function() {
			if(jQuery(this).text() == val) {
				var row = jQuery(this).closest('tr');
				sku = row.find('td.skucol').text();
				width = row.find('td.width').text();
				height = row.find('td.height').text();
				price = row.find('td.pricecol .woocommerce-Price-amount bdi').text();
				per_m2 = row.find('td.per_m2').text();
				out_of_stock = row.find('td.stock').text();
				return false;
			}
		});
		console.log('stock var: '+out_of_stock);
		if(out_of_stock == 'Out of Stock') {
			jQuery('.prod_var_select__info .out_of_stock').remove();
			jQuery('.prod_var_select__info').prepend('<p class="out_of_stock">This variation is out of stock.</p>');
			console.log('product is out of stock');
		} else {
			jQuery('.prod_var_select__info .out_of_stock').remove();
			console.log('product is in stock');
		}
		jQuery('.prod_var_select__info .width span').text(width);
		jQuery('.prod_var_select__info .height span').text(height);
		jQuery('.prod_var_select__info .sku strong').text(sku);
		jQuery('.prod_var_select__info .prod_var_select__price span').text(price);
		jQuery('.prod_var_select__info .prod_var_select__sq_m span').text(per_m2);
		jQuery('.prod_var_select__info').show();

		jQuery(this).closest('.prod_var_select').find('.save_basket').removeClass('hidden');
	});
	jQuery('.prod_var_select__add').click( function() {
		var qtyVal = jQuery(this).closest('.prod_var_select__add_bsk').find('input').val();
		var selProd = jQuery('.prod_var_select__select_prod select.choices__input').val();
		jQuery('.prod_table .desccol p').each( function() {
			if(jQuery(this).text() == selProd) {
				var row = jQuery(this).closest('tr');
				row.find('td.cartcol input[name=quantity]').val(qtyVal);
				row.find('td.cartcol button.add_to_cart').click();
				return false;
			}
		});
	});



	// Update hidden quantity field for add to basket
	jQuery('td.qtycol input.qty').change( function() {
		var qty = jQuery(this).val();
		jQuery(this).closest('tr').find('td.cartcol input[name=quantity]').val(qty);
	});




	// Get list of products while typing a search
	jQuery('input#input-top-search').on('input', function() {
		var val = jQuery(this).val();
        var lang = jQuery(this).data('lang');
		jQuery('.woocommerce-product-search__results').empty();
		if(val) {
			jQuery('.woocommerce-product-search__results').empty();
			jQuery('.woocommerce-product-search__results').show();
			jQuery('.woocommerce-product-search').addClass('results_show');
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				data: {
					'action':'ajax_product_search', // This is our PHP function below
					'value' : val,
				},
				success: function(search) {
					jQuery('.woocommerce-product-search__results').empty();
					// console.log(search);
					var results = search;
					var results_arr = JSON.parse(results);
					if(results_arr['products'] !== null || results_arr['categories'] !== null) {
						console.log(results_arr);
						if(results_arr['products'] !== null) {
							for(var i = 0; i < results_arr['products'].length; i++) {
								jQuery('.woocommerce-product-search__results').append('<a href="'+results_arr['products'][i][0]+'">'+results_arr['products'][i][1]+'</a>');
							}
							jQuery('.woocommerce-product-search__results').append('<a href="'+lang+'?s='+val+'" class="view_all"><span>View all results</span></a>');
						}
						if(results_arr['categories'] !== null) {
							for(var i = 0; i < results_arr['categories'].length; i++) {
								jQuery('.woocommerce-product-search__results').append('<a href="'+results_arr['categories'][i][0]+'">'+results_arr['categories'][i][1]+'</a>');
							}
						}
					} else {
						jQuery('.woocommerce-product-search__results').append('<p>No results found</p>');
					}
				}
			});
		} else {
			jQuery('.woocommerce-product-search__results').empty();
			jQuery('.woocommerce-product-search__results').hide();
			jQuery('.woocommerce-product-search').removeClass('results_show');
		}
	});

	jQuery('.woocommerce-product-search__results').mouseleave(function () {
		jQuery('.woocommerce-product-search__results').empty();
		jQuery('.woocommerce-product-search__results').hide();
		jQuery('.woocommerce-product-search').removeClass('results_show'); 
	}).mouseleave();

	// My account page orders slider
	var prodsliderThumbs = new Swiper('.orders_slider.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	jQuery(document).on('keypress',function(e) {
		if(e.which == 13) {
			jQuery( '.save_basket__btn' ).trigger('click');
			return false;
		}
	});

	jQuery('.choices__item--selectable').click( function() {
		setTimeout(function() { 
			jQuery('.choices').removeClass('is-focused');
		}, 2000);
		
	});

	// Save basket
	jQuery('.save_basket__btn').click( function() {
		
		if(jQuery(this).hasClass('save_basket__btn--prod_page')) {
			var selected_prod = jQuery(this).closest('.prod_var_select').find('.prod_var_select__select_prod select.choices__input').val();
			var row;
			jQuery(this).closest('.prod_tab__content').find('.prod_table td.desccol p').each( function() {
				if(jQuery(this).text() == selected_prod) {
					row = jQuery(this).closest('tr');
				}
			});
			var prod_id = row.attr('data-prod-id');
			var var_id = row.attr('data-variation-id');
			var qty = jQuery('.prod_var_select__qty input').val();
			var sku = row.attr('data-sku');

			var product_detes = prod_id+',product_variation,'+qty+','+var_id+','+sku;
			jQuery('.save_basket input.product_id_qty').val(product_detes);
		}
		if(jQuery('.save_basket select.choices__input').val()) {

			jQuery('.save_basket__btn').text('ADDING');
			jQuery('.save_basket__btn').css('opacity', '0.6');

			jQuery('.save_basket .choices__inner').css('border', '');

			var products = jQuery('.save_basket input.product_id_qty').val();
			var basket_id = jQuery('.save_basket select.choices__input').val();
			
			if(basket_id == 'new') {
				console.log('create new basket');
				jQuery('.save_basket_pop--new').addClass('open');
			}
			// If we're updating an exising basket
			else {
				jQuery.ajax({
					url: my_ajax_object.ajax_url,
					data: {
						'action' : 'add_to_existing_basket',
						'basket_id' : basket_id,
						'products' : products,
					},
					success: function(data) {
						var update_data = data;
						var update_arr = JSON.parse(update_data);
						var basket_arr = JSON.parse(update_arr[1]);
						console.log(basket_arr);
						var basket_name = basket_arr['basket_name'];
						console.log(basket_name);
						if(update_arr[0] > 0) {
							if(update_arr[0] > 1) {
								jQuery('.save_basket_pop--updated .save_basket_pop__title').text(update_arr[0]+' products added to '+basket_name);
							} else {
								jQuery('.save_basket_pop--updated .save_basket_pop__title').text(update_arr[0]+' product added to '+basket_name);
							}
						} else {
							jQuery('.save_basket_pop--updated .save_basket_pop__title').text(basket_name+' updated');
						}
						jQuery('.save_basket_pop--updated').addClass('open');
					}
				});
			}

			jQuery('.save_basket__btn').text('ADD');
			jQuery('.save_basket__btn').css('opacity', '1');

		} else {
			jQuery('.save_basket .choices__inner').css('border', '1px solid #f00');
		}
		
	});

	jQuery('.save_basket_pop__save').click( function() {
		var user_id = jQuery('input.user_id').val();
		var basket_name = jQuery('input.basket_name').val();
		var products = jQuery('input.product_id_qty').val();

		jQuery('.save_basket_pop--created .save_basket_pop__title > span').text(basket_name);

		console.log('button clicked - AJAX next');

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'save_basket_to_db',
				'user_id' : user_id,
				'basket_name' : basket_name,
				'products' : products,
			},
			success: function(data) {
				console.log('basket saved');
				jQuery('.save_basket_pop--new').removeClass('open');
				jQuery('.save_basket_pop--created').addClass('open');
			},
			error: function(req, err){ console.log(err); }
		});
	});

	// Close popups
	jQuery('.save_basket_pop__ok, .save_basket_pop__close, .save_basket_pop__btn--cancel').click( function() {
		jQuery(this).closest('.save_basket_pop').removeClass('open');
	});
	

	
	// Add product to favourites
	jQuery(".add-to-fave").click(function () {
		var that = jQuery(this);
		that.addClass("loading");
		jQuery.ajax({
			url: "/wp-json/hypergram/v1/favourite",
			method: "POST",
			data: {
				sku: that.data("sku"),
				user_id: that.data("userId"),
			},
		}).done(function () {
			that.toggleClass("favourited");
			that.removeClass("loading");
			that
				.attr(
					"title",
					that.hasClass("favourited")
						? "Remove from favourites"
						: "Add to favourites"
				)
				.tooltip("dispose")
				.tooltip();
		});
	});




	// Open / close saved basket tabs
	jQuery('.account_tab__expand').click( function() {
		jQuery(this).closest('.account_tab').find('.account_tab__content').slideToggle();
	});

	// prod table sort buttons
	jQuery('.account_tab__ctrl_btn').click( function() {
		jQuery('.account_tab__ctrl_btn').removeClass('active');
		jQuery(this).addClass('active');

		if(jQuery(this).hasClass('all')) {
			jQuery(this).closest('.account_tab').find('.saved_prods tbody tr').show();
		} else if(jQuery(this).hasClass('in_stock')) {
			var stock = jQuery(this).closest('.account_tab').find('.saved_prods tbody tr td.stock');
			stock.each( function() {
				if(jQuery(this).text() == 'In stock') {
					jQuery(this).closest('tr').show();
				} else {
					jQuery(this).closest('tr').hide();
				}
			});
		} else {
			var stock = jQuery(this).closest('.account_tab').find('.saved_prods tbody tr td.stock');
			stock.each( function() {
				if(jQuery(this).text() !== 'In stock') {
					jQuery(this).closest('tr').show();
				} else {
					jQuery(this).closest('tr').hide();
				}
			});
		}
	});

	// if thead checkbox is checked
	jQuery('.saved_prods thead th .checkbox, .prod_table thead th .checkbox').click( function() {
		jQuery(this).toggleClass('checked');

		if(jQuery(this).hasClass('checked')) {
			jQuery(this).closest('.saved_prods, .prod_table').find('tbody td.select .checkbox:not(.disabled)').addClass('checked');
			jQuery(this).closest('.account_tab, .prod_tab__content').find('.add_selected_prods, .add_selected_quote_prods').removeClass('disabled');
		} else {
			jQuery(this).closest('.saved_prods, .prod_table').find('tbody td.select .checkbox:not(.disabled)').removeClass('checked');
			jQuery(this).closest('.account_tab, .prod_tab__content').find('.add_selected_prods, .add_selected_quote_prods').addClass('disabled');
		}
	});

	// toggle tick in checkboxes
	function toggle_checkbox_tick() {
		jQuery('td.select .checkbox:not(.disabled)').click( function() {
			jQuery(this).toggleClass('checked');

			if(jQuery(this).closest('.account_tab, .prod_tab__content').find('td.select .checkbox.checked:not(.disabled)').length > 0) {
				jQuery(this).closest('.account_tab, .prod_tab__content').find('.add_selected_prods, .add_selected_quote_prods').removeClass('disabled');
			} else {
				jQuery(this).closest('.account_tab, .prod_tab__content').find('.add_selected_prods, .add_selected_quote_prods').addClass('disabled');
			}

			if(jQuery(this).closest('.saved_prods').find('td.select .checkbox.checked:not(.disabled)').length < jQuery(this).closest('.saved_prods').find('td.select .checkbox:not(.disabled)').length) {
				jQuery(this).closest('.saved_prods').find('th .checkbox').removeClass('checked');
			} else {
				jQuery(this).closest('.saved_prods').find('th .checkbox').addClass('checked');
			}
		});
	}
	toggle_checkbox_tick();

	// remove a product from favourites
	jQuery('.account_tab--favourites .saved_prods td.action .bin').click( function() {
		var that = jQuery(this);
		var row = jQuery(this).closest('tr');
		row.addClass("loading");
		jQuery.ajax({
			url: "/wp-json/hypergram/v1/favourite",
			method: "POST",
			data: {
				sku: that.attr("data-sku"),
				user_id: that.attr("data-user-id"),
			},
		}).done(function () {
			row.remove();
		});
	});

	// Add selected favourites to basket
	jQuery('.add_selected_prods').click( function() {
		if(!jQuery(this).hasClass('disabled')) {
			if(jQuery(this).closest('.account_tab').find('.account_tab__content').length) {
				var acc_content = jQuery(this).closest('.account_tab').find('.account_tab__content');
			} else {
				var acc_content = jQuery(this).closest('.prod_tab__content');
			}
			acc_content.addClass('loading');

			var checked = jQuery(this).closest('.account_tab, .prod_tab__content').find('td.select .checkbox.checked');
			var prods = [];
			var quantity = 0;
			checked.each( function() {
				// prods.push(jQuery(this).data('id'));
				if(jQuery(this).closest('tr').find('.fav_qty').length) {
					quantity = jQuery(this).closest('tr').find('.fav_qty').val();
				}
				else if(jQuery(this).closest('tr').find('.qtycol input').length) {
					quantity = jQuery(this).closest('tr').find('.qtycol input').val();
				}
				else {
					quantity = 1;
				}

				console.log('quantity: ');
				console.log(quantity);

				var prod_id = jQuery(this).data('id');
				var prod = [{prod_id, quantity}];

				console.log('prod: ');
				console.log(prod);

				prods.push(prod);
			});

			console.log('prods: ');
			console.log(prods);

			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				data: {
					'action' : 'add_selected_faves_to_basket',
					'prods' : prods,
				},
				success: function(data) {
					console.log(data);
					location.reload();
					acc_content.removeClass('loading');
				}
			});
		}
	});

	// Add selected quote products to basket
	jQuery('.add_selected_quote_prods').click( function() {
		if(!jQuery(this).hasClass('disabled')) {
			if(jQuery(this).closest('.account_tab').find('.account_tab__content').length) {
				var acc_content = jQuery(this).closest('.account_tab').find('.account_tab__content');
			} else {
				var acc_content = jQuery(this).closest('.prod_tab__content');
			}
			acc_content.addClass('loading');

			var quote_key = jQuery(this).data('quote-key');

			var checked = jQuery(this).closest('.account_tab, .prod_tab__content').find('td.select .checkbox.checked');
			var prods = {};
			checked.each( function() {

				var prod_sku = jQuery(this).data('sku');
				var quantity = jQuery(this).closest('tr').find('.quantity input[name=quantity]').val();

				console.log('prod: ');
				console.log(prod_sku);

				console.log('prod quantity: ');
				console.log(quantity);

				prods[prod_sku] = quantity;
			});

			console.log('prods: ');
			console.log(prods);

			var json = JSON.stringify(prods);
			console.log('json prods: ');
			console.log(json);

			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				contentType: 'application/json',
				data: {
					'action' : 'add_selected_quote_products_to_basket',
					'prods' : json,
					'quote_key' : quote_key
				},
				success: function(data) {
					console.log(data);
					location.reload();
					acc_content.removeClass('loading');
				}
			});
		}
	});

	// Text search favourited products
	jQuery('.account_tab__search input[name=search_favourites]').on('input', function() {
		var text = jQuery(this).val().toLowerCase();
		jQuery(this).closest('.account_tab').find('.saved_prods tbody tr').hide();
		jQuery(this).closest('.account_tab').find('.saved_prods tbody tr td.desc a').each( function() {
			var title = jQuery(this).text().toLowerCase();
			if(title.indexOf(text) >= 0) {
				jQuery(this).closest('tr').show();
			}
		});
	});

	// Text search saved baskets
	jQuery('.account_tab__search input[name=search_baskets]').on('input', function() {
		var text = jQuery(this).val().toLowerCase();
		jQuery(this).closest('#saved-baskets').find('.account_tab--basket').hide();
		jQuery(this).closest('#saved-baskets').find('.account_tab--basket').each( function() {
			var title = jQuery(this).find('.account_tab__title .bskt_name').text().toLowerCase();
			if(title.indexOf(text) >= 0) {
				jQuery(this).closest('.account_tab--basket').show();
			}
			var producttable = jQuery(this).find('.account_tab__content .saved_prods tbody'); 
			
			jQuery(producttable).find('tr').each( function() {
				var sku = jQuery('.sku', this).text().toLowerCase();

				if(sku.indexOf(text) >= 0) {
					jQuery(this).closest('.account_tab--basket').show();
				}

				var producttitle = jQuery('.desc', this).text().toLowerCase();

				if(producttitle.indexOf(text) >= 0) { 
					jQuery(this).closest('.account_tab--basket').show();
				}

			});
			
		});
	});

	// remove a product from saved basket
	jQuery('.account_tab--basket .saved_prods td.action .bin').click( function() {
		var prod_id = jQuery(this).data('product-id');
		var var_id = jQuery(this).data('variation-id');
		var sku = jQuery(this).data('sku');
		var basket_id = jQuery(this).data('basket-id');
		console.log(prod_id);
		console.log(var_id);
		console.log(basket_id);

		if(jQuery(this).closest('.saved_prods tbody').find('tr').length > 1) {
			var remove_basket = 'false';
		} else {
			var remove_basket = 'true';
		}

		var row = jQuery(this).closest('tr');
		var tab_content = jQuery(this).closest('.account_tab__content');
		var basket = jQuery(this).closest('.account_tab');

		if(remove_basket == 'true') {
			tab_content.addClass('loading');
		} else {
			row.addClass('loading');
		}

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'remove_product_from_saved_basket',
				'prod_id' : prod_id,
				'var_id' : var_id,
				'sku' : sku,
				'basket_id' : basket_id,
				'remove_basket' : remove_basket,
			},
			success: function() {
				if(remove_basket == 'true') {
					basket.remove();
					tab_content.removeClass('loading');
				} else {
					row.remove();
				}
				console.log('product removed from basket');
			}
		});
	});

	jQuery('.saved_prods .action .edit').click( function() {

		if (jQuery(this).parent().parent().parent().hasClass('editing')) {

			var sku = jQuery(this).data('sku');

			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				data: {
					'action' : 'update_saved_product',
					'sku' : sku,
					'quantity' : jQuery(this).parent().parent().parent().find('.quantity .savedqty').val(),
				},
				success: function(data) {
					
				}
			});

			jQuery(this).parent().parent().parent().find('.quantity .qtystatic').text(jQuery(this).parent().parent().parent().find('.quantity .savedqty').val());
			jQuery(this).parent().parent().parent().removeClass('editing');
			jQuery(this).html('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1667 2.50005C14.3856 2.28118 14.6455 2.10756 14.9314 1.98911C15.2174 1.87066 15.5239 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7354 1.98911C17.0214 2.10756 17.2812 2.28118 17.5001 2.50005C17.719 2.71892 17.8926 2.97875 18.011 3.26472C18.1295 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1295 4.78274 18.011 5.06871C17.8926 5.35468 17.719 5.61451 17.5001 5.83338L6.25008 17.0834L1.66675 18.3334L2.91675 13.75L14.1667 2.50005Z" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>');

		} else {
			jQuery(this).parent().parent().parent().addClass('editing');
			jQuery(this).html('<svg width="17" height="17" viewBox="0 0 29 21" fill="#667085" xmlns="http://www.w3.org/2000/svg"><path fill="#667085" d="M28.4125 0.587524C29.1937 1.36877 29.1937 2.63752 28.4125 3.41877L12.4125 19.4188C11.6312 20.2 10.3625 20.2 9.58124 19.4188L1.58124 11.4188C0.799988 10.6375 0.799988 9.36877 1.58124 8.58752C2.36249 7.80627 3.63124 7.80627 4.41249 8.58752L11 15.1688L25.5875 0.587524C26.3687 -0.193726 27.6375 -0.193726 28.4187 0.587524H28.4125Z" fill="black"/></svg>');
		}

	});

	jQuery('.account_tab__head .edittitle').click( function() {

		if (jQuery(this).parent().hasClass('editing')) {

			var basket_id = jQuery(this).data('basket-id');

			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				data: {
					'action' : 'update_saved_product',
					'basket_id' : basket_id,
					'basket_name' : jQuery(this).parent().find('.account_tab__title .basket-name').val(),
				},
				success: function(data) {
					
				}
			});

			jQuery(this).parent().find('.account_tab__title .b_name').text(jQuery(this).parent().find('.account_tab__title .basket-name').val());
			jQuery(this).parent().removeClass('editing');
			jQuery(this).html('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1667 2.50005C14.3856 2.28118 14.6455 2.10756 14.9314 1.98911C15.2174 1.87066 15.5239 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7354 1.98911C17.0214 2.10756 17.2812 2.28118 17.5001 2.50005C17.719 2.71892 17.8926 2.97875 18.011 3.26472C18.1295 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1295 4.78274 18.011 5.06871C17.8926 5.35468 17.719 5.61451 17.5001 5.83338L6.25008 17.0834L1.66675 18.3334L2.91675 13.75L14.1667 2.50005Z" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>');

		} else {
			jQuery(this).parent().addClass('editing');
			jQuery(this).html('<svg width="17" height="17" viewBox="0 0 29 21" fill="#667085" xmlns="http://www.w3.org/2000/svg"><path fill="#667085" d="M28.4125 0.587524C29.1937 1.36877 29.1937 2.63752 28.4125 3.41877L12.4125 19.4188C11.6312 20.2 10.3625 20.2 9.58124 19.4188L1.58124 11.4188C0.799988 10.6375 0.799988 9.36877 1.58124 8.58752C2.36249 7.80627 3.63124 7.80627 4.41249 8.58752L11 15.1688L25.5875 0.587524C26.3687 -0.193726 27.6375 -0.193726 28.4187 0.587524H28.4125Z" fill="black"/></svg>');
		}

	});

	// bin a saved basket
	jQuery('.account_tab--basket .bin_basket').click( function() {
		var basket_id = jQuery(this).data('basket-id');
		console.log(basket_id);
		
		var basket = jQuery(this).closest('.account_tab--basket');
		var tab_content = jQuery(this).closest('.account_tab--basket').find('.account_tab__content');

		tab_content.addClass('loading');

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'remove_a_saved_basket',
				'basket_id' : basket_id,
			},
			success: function() {
				basket.remove();
				tab_content.removeClass('loading');
				console.log('product removed from basket');
			}
		});
	});


	// Account dashboard navigation drop down
	jQuery('.sidebar-nav .nav-item .nav-link.has_dropdown').click( function() {
		if(jQuery(window).width() > 700) {
			jQuery(this).closest('.nav-link.has_dropdown').toggleClass('open');
			jQuery(this).closest('.nav-link.has_dropdown').find('.has_dropdown__drop').slideToggle();
		} else {
			jQuery('.sidebar-nav > .has_dropdown__drop').remove();
			jQuery(this).closest('.nav-link.has_dropdown').find('.has_dropdown__drop').clone().insertAfter('.sidebar-nav > .nav-item');
			jQuery('.sidebar-nav > .has_dropdown__drop').addClass('mob_drop');

			jQuery('.sidebar-nav > .has_dropdown__drop.mob_drop .cross').click( function() {
				jQuery(this).closest('.has_dropdown__drop.mob_drop').remove();
			});
		}
	});



	// Intercept add basket to basket and check for out of stock products
	jQuery('.account_tab__bskt_btn--saved_b').click( function(e) {
		e.preventDefault();
		var href = jQuery(this).attr('href');
		var out_stock_count = 0;
		jQuery(this).closest('.account_tab--basket').find('table.saved_prods tbody tr').each( function() {
			if(jQuery(this).data('stock') !== 'instock') {
				out_stock_count++;
			}
		});

		// If no products are out of stock then proceed
		if(out_stock_count == 0) {
			var box_count = 0;
			var check_count = 0;
			jQuery(this).closest('.account_tab--basket').find('.saved_prods .select .checkbox').each( function() {
				box_count++;
				if(jQuery(this).hasClass('checked')) {
					check_count++;
				}
			});
			if(check_count == box_count || check_count == 0) {
				window.location.href = href;
			}
			else {
				var prods_to_add = [];
				jQuery(this).closest('.account_tab--basket').find('.saved_prods .select .checkbox').each( function() {
					if(jQuery(this).hasClass('checked') && jQuery(this).closest('tr').data('stock') == 'instock') {
						let sku = jQuery(this).closest('tr').find('td.sku').text();
						let qty = jQuery(this).closest('tr').find('td.quantity').text();
						prods_to_add.push(sku+'|'+qty);
					}
				});
				var curr_page = window.location.href;
				var new_url = curr_page.split('?');
				window.location.href = new_url[0] + '?add_prods='+prods_to_add;
			}
		} else {
			if(out_stock_count == 1) {
				jQuery('.save_basket_pop--out_of_stock .save_basket_pop__title').text('1 product is out of stock');
			} else {
				jQuery('.save_basket_pop--out_of_stock .save_basket_pop__title').text(out_stock_count+' products are out of stock');
			}
			jQuery('.save_basket_pop').addClass('open');

			jQuery('.save_basket_pop--out_of_stock .save_basket_pop__proceed').click( function() {
				window.location.href = href;
			});
		}
	});



	// Add anotherables - company users page
	var anotherable_click_i = 1;
	jQuery('.woocommerce-form-login__add_another').click( function() {
		anotherable_click_i++;
		jQuery('.add_anotherable:last-child').clone().insertAfter('.add_anotherable:last-child').find('input').val('');

		// If its a billing address form email
		if(jQuery(this).hasClass('woocommerce-form-login__add_another--bill_email')) {
			var form_name = jQuery('#address_form').data('address-form');
			var new_field = jQuery('.add_anotherable:last-child');

			new_field.find('input').attr('name', form_name+'_email_'+anotherable_click_i);
		}
	});



	// Tag tabs
	jQuery('.tag_tabs__menu_item').click( function() {
		if(!jQuery(this).hasClass('dis')) {
			var tab_name = jQuery(this).attr('data-name');
			jQuery('.tag_tabs__menu_item').removeClass('active');
			jQuery('.tag_tabs__content').removeClass('active');
			jQuery(this).addClass('active');
			jQuery('.tag_tabs__content[data-name='+tab_name+']').addClass('active');
		}
	});



	// Address settings menu open
	jQuery('.address_box__settings > svg').click( function() {
		jQuery(this).closest('.address_box__settings').find('.address_box__settings__menu').toggleClass('open');
	});
	jQuery('.address_box__settings__menu > a').click( function() {
		jQuery(this).closest('.address_box__settings__menu').removeClass('open')
		if(jQuery(this).hasClass('wc-address-book-delete') || jQuery(this).hasClass('wc-address-book-make-primary')) {
			location.reload();
		}
	});



	// Basket product quantity controls
	jQuery('.basket_prod__qty .qty_btn').click( function() {
		if(!jQuery(this).hasClass('disabled')) {
			var qty_input = jQuery(this).closest('.qty_ctrl').find('.quantity > input[type="number"]');
			var curr_val = parseInt(qty_input.val());
			if(jQuery(this).hasClass('minus')) {
				var new_val = curr_val - 1;
			} else {
				var new_val = curr_val + 1;
			}

			if(new_val == 1) {
				if(jQuery(this).hasClass('minus')) {
					jQuery(this).addClass('disabled');
				}
			} else {
				jQuery(this).closest('.qty_ctrl').find('.qty_btn.minus').removeClass('disabled');
			}
			qty_input.val(new_val);

			jQuery('input[name=update_cart]').prop('disabled', false);
		}
	});

	// if a quantity is changed - enabled update cart
	jQuery('.basket_prod__qty .qty_ctrl .quantity>input').change( function() {
		jQuery('input[name=update_cart]').prop('disabled', false);
	});


	jQuery('.qtycol .qty_btn').click(function () {
		if (!jQuery(this).hasClass('disabled')) {
			var qty_input = jQuery(this).closest('.qtycol').find('input.qty');
			var hidden_qty_input = jQuery(this).closest('tr').find('.cartcol input[name=quantity]');
		  
		  if (jQuery(this).hasClass('minus')) {
		  	var curr_val = parseInt(qty_input.val());
			var new_val = curr_val - 1;
		  } else {
		  	var curr_val = parseInt(qty_input.val());
			var new_val = curr_val + 1;
		  }
	
		  if (new_val == 1) {
			if (jQuery(this).hasClass('minus')) {
			  jQuery(this).addClass('disabled');
			}
		  } else {
			jQuery(this).closest('.qtycol').find('.qty_btn.minus').removeClass('disabled');
		  }
	
		  qty_input.val(new_val);
		  hidden_qty_input.val(new_val);
		//   jQuery('input[name=update_cart]').prop('disabled', false);
		}
	  }); 

	// Get selected billing address
	function get_checkout_address(address_name, address_type) {
		if(address_type == 'billing') {
			var field_wrapper = '.woocommerce-billing-fields';
		} else {
			var field_wrapper = '.shipping_address';
		}

		if(address_name == 'add_new') {
			if(jQuery(field_wrapper+' address').length > 0) {
				jQuery(field_wrapper+' address').remove();
			}
			jQuery(field_wrapper+' .form-row').addClass('show');
		} else {
			jQuery(field_wrapper+' .form-row').removeClass('show');
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				data: {
					'action' : 'get_checkout_address', // This is our PHP function below
					'address_name' : address_name,
					'address_type' : address_type,
				},
				success: function(response) {
					const address = JSON.parse(response);
					let address_text = '';
					console.log(address.type);
					if(jQuery(field_wrapper + ' address').length == 0) {
						jQuery(field_wrapper).append('<address></address>');
					}
					for (var key in address) {
						if(address[key] && key !== 'address_nickname' && address[key] !== '0') {
							address_text += address[key] + '<br>';
						}
					}
					jQuery(field_wrapper + ' address').html(address_text);
					if(address_type == 'billing') {
						jQuery('.woocommerce-billing-fields address').append('<span class="edit_address"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1667 2.50005C14.3856 2.28118 14.6455 2.10756 14.9314 1.98911C15.2174 1.87066 15.5239 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7354 1.98911C17.0214 2.10756 17.2812 2.28118 17.5001 2.50005C17.719 2.71892 17.8926 2.97875 18.011 3.26472C18.1295 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1295 4.78274 18.011 5.06871C17.8926 5.35468 17.719 5.61451 17.5001 5.83338L6.25008 17.0834L1.66675 18.3334L2.91675 13.75L14.1667 2.50005Z" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
						edit_address_pencil();
					}
				}
			});
		}
	}
	var billing_address = jQuery('select#billing_address_book.choices__input').val();
	get_checkout_address(billing_address, 'billing');

	jQuery('select#billing_address_book.choices__input').on('change', function() {
		var address_name = jQuery(this).val();
		get_checkout_address(address_name, 'billing');
	});

	var shipping_address = jQuery('select#shipping_address_book.choices__input').val();
	get_checkout_address(shipping_address, 'shipping');

	jQuery('select#shipping_address_book.choices__input').on('change', function() {
		var address_name = jQuery(this).val();
		get_checkout_address(address_name, 'shipping');
	});

	function edit_address_pencil() {
		jQuery('.edit_address').click( function() {
			jQuery(this).closest('.checkout_address').find('.form-row').addClass('show');
		});
	}



	// Add coupon JS for basket and checkout pages
	jQuery('.add-coupon_coupon-msg .add_coupon').click( function() {
		jQuery('.basket_totals__coupon').removeClass('hide');
		jQuery(this).remove();
	});
	jQuery('.basket_totals__coupon__btn').click( function() {
		var val = jQuery('.basket_totals__coupon__input').val();
		jQuery('#coupon_code').val(val);
		jQuery('#button-coupon-apply').click();
	});
	if(jQuery('.alert.alert-danger').length) {
		jQuery('.add-coupon_coupon-msg').html('<span class="coupon_invalid">Invalid coupon</span>');
		jQuery('.basket_totals__coupon').removeClass('hide');
		jQuery('.basket_totals__coupon').addClass('error');
		jQuery('.add-coupon_coupon-msg .add_coupon').remove();
	}
	jQuery('.remove_coupon').click( function() {
		var code = jQuery(this).data('code');
		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'remove_coupon',
				'code' : code,
			},
			success: function(response) {
				location.reload();
			}
		});
	});



	// Cancel button on edit account form
	jQuery('.empty_form').click( function() {
		jQuery(this).closest('form').find('input').each( function() {
			var disabled = jQuery(this).attr('disabled');
			if(!disabled) {
				jQuery(this).val('');
			}
		});
	});



	// Delete profile picture button
	jQuery('.upload_btns__btn--delete').click( function() {
		jQuery('.image_upload img').remove();
		jQuery('.image_upload .upload_btn').val('');
		jQuery('#image_upload').prop('disabled', false);
	});

	jQuery(window).scroll(function() {
		var scrollnav = jQuery(window).scrollTop();
		if (scrollnav > 119) {
			jQuery('header.header .bar-products').addClass('fixed')
		} else {
			jQuery('header.header .bar-products').removeClass('fixed')
		}
	});




	// Orders drop down
	var displayOrders = function (owID) {
		jQuery.get(("/wp-json/hypergram/v1/orders/?owid=" + owID), function (data) {
			var response = JSON.parse(data);
			jQuery('#currentOrders').html('');
			response.current.forEach(function(order) {
				jQuery('#currentOrders').append(order);
			});
			jQuery('#pastOrders').html('');
			response.past.forEach(function(order) {
				jQuery('#pastOrders').append(order);
			});
		});
	}
	if (jQuery('.hgr-orders').length) {
		// is orders page

		var owID$1 = jQuery('#hgrOrders').data('owid');

		jQuery('body').on('click', '.order-item', function() {
			var orderId = jQuery(this).data('order');
			var $liContainer = jQuery('#' + orderId)
				.find('.line-items-container')
				.eq(0);

			if ($liContainer.hasClass('active')) {
				$liContainer.removeClass('active');
			} else {
				$liContainer.addClass('active');
			}

			if (!jQuery('#' + orderId + 'Lineitems').hasClass('loaded')) {
				displayLineitems(orderId);
			}
		});

		displayOrders(owID$1);
	}



	// Enter to search
	jQuery('.woocommerce-product-search input').keypress( function(event) {
		var keycode = (event.keyCode ? event.keyCode : event.which);
		if(keycode == '13') {
			// event.preventDefault();
			// jQuery(this).closest('.woocommerce-product-search').find('button').click();
			// var search = jQuery(this).val();
			// var url = window.location.origin;
			// var search_url = url + '?s=' + search;
			// window.location.href = search_url;
            jQuery(this).closest('.woocommerce-product-search').trigger('submit');
		}
	});


	// Scrolling totals on basket and checkout pages
	// jQuery(window).scroll(function () {

	// 	if(jQuery('#cart_totals').length) {
	// 		var cart_height = jQuery('.woocommerce-cart-form').height();
	// 		var tots_height = jQuery('#cart_totals').height();

	// 		// console.log('tots_cont_height: '+tots_cont_height);
	// 		// console.log('tots_height: '+tots_height);

	// 		if((cart_height + 40) > tots_height) {
	// 			var tots_cont_y = jQuery('.cart-collaterals')[0].getBoundingClientRect()['y'];
	// 			var tots_cont_width = jQuery('.cart-collaterals').width();
	// 			if(tots_cont_y <= 0) {
	// 				jQuery('#cart_totals').css('position', 'absolute');
	// 				jQuery('#cart_totals').css('bottom', '0px');
	// 			} else {
	// 				jQuery('#cart_totals').css('position', 'fixed');
	// 				jQuery('#cart_totals').css('bottom', '10px');
	// 				jQuery('#cart_totals').css('width', tots_cont_width+'px');
	// 			}
	// 		} else {
	// 			jQuery('#cart_totals').css('position', 'initial');
	// 		}
	// 	}

	// 	if(jQuery('#checkout_totals').length) {
	// 		var checkout_height = jQuery('#checkout_form_fields').height();
	// 		var tots_height = jQuery('#checkout_totals').height();

	// 		console.log('checkout_height: '+checkout_height);
	// 		console.log('tots_height: '+tots_height);

	// 		if((checkout_height + 200) > tots_height && tots_height < window.innerHeight) {
	// 			var tots_cont_y = jQuery('#totals_container')[0].getBoundingClientRect()['y'];
	// 			var tots_cont_width = jQuery('#totals_container').width();
	// 			var tots_y = jQuery('#checkout_totals')[0].getBoundingClientRect()['y'];

	// 			console.log('tots_cont_y: '+tots_cont_y);
	// 			console.log('tots_cont_width: '+tots_cont_width);
	// 			console.log('tots_y: '+tots_y);
	// 			console.log('------------');

	// 			if(tots_cont_y <= 0 && tots_y > 0) {
	// 			// if(tots_cont_y <= 0) {
	// 				jQuery('#checkout_totals').css('position', 'absolute');
	// 				jQuery('#checkout_totals').css('bottom', '0px');
	// 			} else {
	// 				jQuery('#checkout_totals').css('position', 'fixed');
	// 				jQuery('#checkout_totals').css('bottom', '10px');
	// 				jQuery('#checkout_totals').css('width', tots_cont_width+'px');
	// 			}
	// 		} else {
	// 			jQuery('#checkout_totals').css('position', 'initial');
	// 		}
	// 	}

	// });



	// Filter search
	jQuery('.filt_submit, .colour, .check_cont input[type=checkbox]').click( function() {
		jQuery(this).closest('.cat_filter__filt').addClass('filtered');

		var prod_area = jQuery('.category_flex__col_2');
		prod_area.addClass('loading');
		jQuery('.category_flex__col_2 .products.page, .category_flex__col_2 .show_more').remove();
        var lang = prod_area.data('lang');

		if(jQuery(this).hasClass('colour')) {
			jQuery(this).toggleClass('selected');
		}

		var filters = {};
		jQuery('.cat_filter__filt.filtered').each(function() {
			var meta = jQuery(this).closest('.cat_filter__filt').data('filter');
			var data_type = jQuery(this).closest('.cat_filter__filt').data('type');
			filters[meta] = {};
			filters[meta]['data_type'] = data_type;

			if(meta == 'colour') {
				filters[meta]['values'] = {};
				var selected_colours = jQuery(this).find('.colour.selected');
				for(var i = 0; i < selected_colours.length; i++) {
					filters[meta]['values'][i] = jQuery(selected_colours[i]).data('term');
				};
			}
			else if(data_type == 'Decimal') {
				var max = jQuery(this).closest('.cat_filter__filt').find('input[name=max]').val();
				var min = jQuery(this).closest('.cat_filter__filt').find('input[name=min]').val();
				filters[meta]['min'] = min;
				filters[meta]['max'] = max;
			}
			else if(data_type == 'var_product') {
				var max = jQuery(this).closest('.cat_filter__filt').find('input[name=max]').val();
				var min = jQuery(this).closest('.cat_filter__filt').find('input[name=min]').val();
				filters[meta]['min'] = min;
				filters[meta]['max'] = max;
			}
			else {
				filters[meta]['values'] = {};
				var selected_checks = jQuery(this).find('input[type=checkbox]:checked');
				for(var i = 0; i < selected_checks.length; i++) {
					filters[meta]['values'][i] = jQuery(selected_checks[i]).val();
				}
			}
		});

		var json = JSON.stringify(filters);
		var term_id = jQuery('.category_flex__col_1').data('term-id');
		var taxonomy = jQuery('.category_flex__col_1').data('taxonomy');

		var url = window.location.href;

		console.log(filters);

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'get_filtered_variations',
				'filters' : json,
				'term_id' : term_id,
				'taxonomy' : taxonomy
			},
			success: function(prod_ids) {

				console.log('START prod_ids-----');
				console.log(prod_ids);
				console.log('END prod_ids-----');

				jQuery.ajax({
					url: url,
					type: 'get',
					data: {
						'prod_ids' : prod_ids,
					},
					success: function(response) {
						var prod_count = jQuery('.category_flex__col_2 > .products .prod_slide', response).length;
						if(prod_count > 1) {
                            if(lang == 'fr_FR') {
                                jQuery('.woocommerce-result-count').text('Afficher les '+prod_count+' résultats');
                            } else {
							    jQuery('.woocommerce-result-count').text('Showing all '+prod_count+' results');
                            }
						} else if(prod_count == 1) {
                            if(lang == 'fr_FR') {
                                jQuery('.woocommerce-result-count').text('Afficher 1 résultat');
                            } else {
                                jQuery('.woocommerce-result-count').text('Showing 1 result');
                            }
						} else {
                            if(lang == 'fr_FR') {
                                jQuery('.woocommerce-result-count').text('Afficher 0 résultats');
                            } else {
							    jQuery('.woocommerce-result-count').text('Showing 0 results');
                            }
						}
						count_products_for_button_text();
						prod_area.removeClass('loading');
						jQuery('.category_flex__col_2 > .products').html(jQuery('.category_flex__col_2 > .products', response).html());
					}
				});
			}
		});
	});

	// Remove 'filtered' class if theres no values
	jQuery('.cat_filter__filt input').change( function() {
		if(jQuery(this).closest('label').find('input:placeholder-shown').length == jQuery(this).closest('label').find('input').length) {
			jQuery(this).closest('.cat_filter__filt').removeClass('filtered');
		}
	});


	// Input[type=range] prevent from overlapping
	jQuery('input[name=min]').each( function() {
		jQuery(this).on('input change', function() {
			var lowerSlider = jQuery(this);
			var upperSlider = jQuery(this).closest('.multi_range').find('input[name=max]')
			var minval = parseInt(lowerSlider[0].value);
			var maxval = parseInt(upperSlider[0].value);
			var min = jQuery(this).attr('min');
			var max = jQuery(this).attr('max');
			
			var ten_percent = Math.round(((max - min) / 100) * 10);

			if (maxval < minval + ten_percent) {
				lowerSlider[0].value = maxval - ten_percent;
				
				if (minval == lowerSlider.min) {
					upperSlider[0].value = ten_percent;
				}
			}

			var tooltip = jQuery(this).closest('.multi_range_cont').find('.range_tooltip--min');
			var range_width = jQuery(this).closest('.multi_range')[0].clientWidth;

			var left = (((parseInt(range_width) - 32) / (parseInt(max) - parseInt(min))) * (parseInt(minval) - parseInt(min))) + 12;
			var left_pos = left + 'px';
			tooltip.css('left', left_pos);
			if(jQuery(this).closest('.cat_filter__filt').data('filter') == '_length') {
				minval = minval / 1000;
			}
			tooltip.find('span').text(minval);
		});
	});
	jQuery('input[name=max]').each( function() {
		jQuery(this).on('input change', function() {
			var lowerSlider = jQuery(this).closest('.multi_range').find('input[name=min]')
			var upperSlider = jQuery(this);
			var minval = parseInt(lowerSlider[0].value);
			var maxval = parseInt(upperSlider[0].value);
			var min = jQuery(this).attr('min');
			var max = jQuery(this).attr('max');
			
			var ten_percent = Math.round(((max - min) / 100) * 10);
			
			if (minval > maxval - ten_percent) {
				upperSlider[0].value = minval + ten_percent;
				
				if (maxval == upperSlider[0].max) {
					lowerSlider[0].value = parseInt(upperSlider[0].max) - ten_percent;
				}
			}

			var tooltip = jQuery(this).closest('.multi_range_cont').find('.range_tooltip--max');
			var range_width = jQuery(this).closest('.multi_range')[0].clientWidth;

			var left = (((parseInt(range_width) - 32) / (parseInt(max) - parseInt(min))) * (parseInt(maxval) - parseInt(min))) + 12;
			var left_pos = left + 'px';
			tooltip.css('left', left_pos);
			if(jQuery(this).closest('.cat_filter__filt').data('filter') == '_length') {
				maxval = maxval / 1000;
			}
			tooltip.find('span').text(maxval);
		});
	});

	// bin a saved basket
	jQuery('.loyalty-wrap__btn').click( function() {

		var currency = jQuery(this).data('currency');
		jQuery('.loyalty-resp').html('');
		jQuery('.discountrow span').text(currency+'0.00');

		var points = jQuery('.loyalty_points').val();

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'apply_loyalty_points',
				'points' : points,
			},
			dataType:"json",
			success: function(response) {
				console.log(jQuery('tr.order-total .amount bdi').after());
				if (response.applied == true) {
					jQuery('.loyalty-resp').html(response.msg);
					jQuery('.discountrow span').text(currency + response.discount);
					jQuery('tr.coupon').hide();
					jQuery(".basket_totals").load(location.href + " .basket_totals");
				} else {
					jQuery('.loyalty-resp').html(response.msg);
				}
				
			}
		});
	});


	// Orders tabs
	jQuery('.orders_nav > span').click( function() {
		var tab = jQuery(this).data('tab');
		jQuery('.orders_row').removeClass('active');
		jQuery('#'+tab).addClass('active');
		jQuery('.orders_nav > span').removeClass('active');
		jQuery(this).addClass('active');
	});



	// Export CSV
	jQuery('#export_csv').on('click', function(e) {
		e.preventDefault();
		var prod_info = [];
	
		jQuery('#order_product_list tr').each(function() {
			var name = jQuery(this).find('.desc_and_sku a').text();
			var sku = jQuery(this).find('.desc_and_sku span').text();
			var qty = jQuery(this).find('.prod_qty').text();
			var price = jQuery(this).find('.prod_price').text();
			var prod = {
				'name': name,
				'sku': sku,
				'qty': qty,
				'price': price,
			};
			prod_info.push(prod);
		});
	
		var prod_json = JSON.stringify(prod_info);
	
		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			type: 'POST',
			data: {
				'action': 'current_order_export_csv',
				'products': prod_json
			},
			dataType: 'text',  // Expect plain text as the response
			success: function(data) {
				// Create a link to download the CSV file
				var csvBlob = new Blob([data], { type: 'text/csv' });
				var csvUrl = URL.createObjectURL(csvBlob);
	
				var link = document.createElement('a');
				link.href = csvUrl;
				link.download = 'exported_data.csv';
				link.click();
			},
			error: function(xhr, status, error) {
				console.log(xhr);
				console.log(status);
				console.log(error);
			}
		});
	});


	// Download invoice button
	jQuery('.download_invoice').click( function() {
		var order_id = jQuery(this).data('order-id');
		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'download_invoice', // This is our PHP function below
				'order_id' : order_id,
			},
			success: function(data) {
				window.open(data);
			},
			error: function(xhr,status,error) {
				console.log(xhr);
				console.log(status);
				console.log(error);
			}
		});
	});



	// Get order info with AJAX
	jQuery('.clickable_order').click( function() {
		var order_id = jQuery(this).data('order-no');
		var order_details = jQuery('#order_details');
		var order_product_list = jQuery('#order_product_list');
		var download_invoice = jQuery('#download_invoice');
		var products_container = jQuery('#products_container');
		var order_details_content = jQuery('#order_details_content');
		var order_information = jQuery('#order_information');
		var clicked_order = jQuery(this);
		var width = jQuery(window).width();
		var order_details_container = jQuery('#order_details_container');
		var currency = jQuery(this).data('currency');

		jQuery('.clickable_order').parent().removeClass('active');
		jQuery(this).parent().addClass('active');

		products_container.addClass('loading');
		order_details_content.addClass('loading');

		var head = jQuery('.header > .bar-products').height();

		if(width > 575) {
			jQuery('html, body').animate({
				scrollTop: jQuery(order_details_container).offset().top - head
			}, 1000);
		}

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'ajax_get_order_details', // This is our PHP function below
				'order_id' : order_id,
			},
			success: function(data) {

				if(width < 576) {
					order_information.insertAfter(clicked_order);
					jQuery('html, body').animate({
						scrollTop: jQuery(order_details_container).offset().top - head
					}, 1000);
				}

				var order_arr = JSON.parse(data);
				console.log(order_arr);

				order_details.find('#order_ref').text(order_arr.order_details.OrderReference);
				order_details.find('#order_date').text(order_arr.order_details.OrderDate);
				order_details.find('#order_vat span').text(order_arr.order_details.OrderValueVAT);

				// if('woo_order' in order_arr) {
				// 	order_details.find('#delivery_charges .text').text('£'+order_arr.woo_order.delivery_charges);
				// 	order_details.find('#shipping_method .text').text(order_arr.woo_order.shipping_method);
				// 	order_details.find('#shipping_address .text').html(order_arr.woo_order.shipping_address);
				// 	order_details.find('#billing_address .text').html(order_arr.woo_order.billing_address);

				// 	order_details.find('#delivery_charges').show();
				// 	order_details.find('#shipping_method').show();
				// 	order_details.find('#shipping_address').show();
				// 	order_details.find('#billing_address').show();
				// } else {
				// 	order_details.find('#delivery_charges').hide();
				// 	order_details.find('#shipping_method').hide();
				// 	order_details.find('#shipping_address').hide();
				// 	order_details.find('#billing_address').hide();
				// }

				var prod_row_html = '';
				for(var i = 0; order_arr.order_products.length > i; i++) {
					var prod = order_arr.order_products[i];

					if(prod.url) {
						var url = prod.url;
						var checked_dis = '';
					} else {
						var url = '#';
						var checked_dis = 'disabled';
					}

					prod_row_html += '<tr>';
					prod_row_html += '<td class="select"><span class="checkbox '+checked_dis+'" data-id="'+prod.id+'"></span></td>';
					prod_row_html += '<td class="desc"><div class="flex">'+prod.image_html+'<div class="desc_and_sku"><a href="'+url+'">'+prod.name+'</a><span>SKU: '+prod.sku+'</span></div></td>';
					prod_row_html += '<td class="price centre_col"><span class="prod_qty">'+prod.quantity+'</span><input type="hidden" class="fav_qty savedqty" name="quantity" value="'+prod.quantity+'"></td>';
					prod_row_html += '<td class="price centre_col"><span class="prod_price">'+currency+''+prod.total+'</span></td>';
					prod_row_html += '</tr>';
				}

				order_product_list.empty();
				order_product_list.html(prod_row_html);

				download_invoice.data('order-id', order_arr.order_details.OrderID);

				products_container.removeClass('loading');
				order_details_content.removeClass('loading');

				// Add checkable checkbox functionality back
				toggle_checkbox_tick();
			},
			error: function(xhr,status,error) {
				console.log(xhr);
				console.log(status);
				console.log(error);
			}
		});
	});

	// Request a POD
	jQuery('.request_pod').click( function() {
		console.log('Request button clicked');
		var order = jQuery('.clickable_order');
		var order_no = order.data('order-no');
		var order_ref = order.data('reference');
		var btn = jQuery(this);
		var popup = jQuery('.save_basket_pop--pod_requested');
		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'request_a_pod', // This is our PHP function below
				'order_no' : order_no,
				'order_ref' : order_ref
			},
			success: function(data) {
				console.log('Success function reached');
				btn.find('span').text('Request Sent');
				popup.addClass('open');
			}
		});
	});

	// Get quote info with AJAX
	jQuery('.clickable_quote').click( function() {
		var quote_id = jQuery(this).data('quote-id');
		var quote_key = jQuery(this).data('quote-key');
		var quote_product_list = jQuery('#quote_product_list');
		// var download_invoice = jQuery('#download_invoice');
		var add_selected_quote_prods = jQuery('#add_selected_quote_prods');
		var products_container = jQuery('#products_container');
		var clicked_quote = jQuery(this);
		var width = jQuery(window).width();
		var order_details_container = jQuery('#order_details_container');
		var currency = jQuery(this).data('currency');

		jQuery('.clickable_quote').parent().removeClass('active');
		jQuery(this).parent().addClass('active');

		products_container.addClass('loading');

		console.log(add_selected_quote_prods);
		console.log('quote_key = '+quote_key);
		add_selected_quote_prods.data('quote-key', quote_key);

		var head = jQuery('.header > .bar-products').height();

		if(width > 575) {
			jQuery('html, body').animate({
				scrollTop: jQuery(order_details_container).offset().top - head
			}, 1000);
		}

		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'ajax_get_quote_products', // This is our PHP function below
				'quote_id' : quote_id,
			},
			success: function(data) {

				if(width < 576) {
					// order_information.insertAfter(clicked_order);
					jQuery('html, body').animate({
						scrollTop: jQuery(order_details_container).offset().top - head
					}, 1000);
				}

				console.log(data);
				var quote_prods = JSON.parse(data);
				console.log(quote_prods);

				var prod_row_html = '';
				for(var i = 0; quote_prods.length > i; i++) {
					var prod = quote_prods[i];

					if(prod.url) {
						var url = prod.url;
						var checked_dis = '';
					} else {
						var url = '#';
						var checked_dis = 'disabled';
					}

					prod_row_html += '<tr class="editing">';
					prod_row_html += '<td class="select"><span class="checkbox '+checked_dis+'" data-sku="'+prod.sku+'"></span></td>';
					prod_row_html += '<td class="desc"><div class="flex">'+prod.image_html+'<div class="desc_and_sku"><a href="'+url+'">'+prod.name+'</a><span>SKU: '+prod.sku+'</span></div></td>';
					if(prod.quantity && prod.quantity !=='') {
						prod_row_html += '<td class="quantity centre_col"><span class="prod_qty">'+prod.quantity+'</span><input type="hidden" class="fav_qty savedqty" name="quantity" value="'+prod.quantity+'"></td>';
					}
					else {
						prod_row_html += '<td class="quantity centre_col"><input type="number" class="fav_qty savedqty" name="quantity" value="1"></td>';
					}
					prod_row_html += '<td class="price centre_col"><span class="prod_price">'+currency+''+prod.price+'</span></td>';
					prod_row_html += '</tr>';
				}

				quote_product_list.empty();
				quote_product_list.html(prod_row_html);

				products_container.removeClass('loading');

				// Add checkable checkbox functionality back
				toggle_checkbox_tick();
			},
			error: function(xhr,status,error) {
				console.log(xhr);
				console.log(status);
				console.log(error);
			}
		});
	});


	// Countdown timer
	if(jQuery('.countdown').length > 0) {
		var h = jQuery('.countdown .hr');
		var m = jQuery('.countdown .min');
		var s = jQuery('.countdown .sec');
		var today = new Date();
		var month = today.getMonth() + 1;
		var countDownDate = new Date(today.getFullYear() + '-' + month + '-' + today.getDate() + ' ' + '16:30:00').getTime();
        var lang = jQuery('.countdown').data('lang');

		var x = setInterval(function() {
			var now = new Date().getTime();
			var distance = countDownDate - now;

			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			h.text(hours);
			m.text(minutes);
			s.text(seconds);

			if (distance < 0) {
				clearInterval(x);

                if(lang == 'fr_FR') {
				    jQuery('.countdown p').text('Temps écoulé');
                }
                else {
                    jQuery('.countdown p').text('Times up');
                }
			}

		}, 1000);
	}


    // Save cookie about the Direct Delivery checkbox
    jQuery(document).on('change', '#direct_delivery', function(){
        var isChecked = jQuery(this).is(':checked') ? 'yes' : 'no';

        jQuery.ajax({
            url: my_ajax_object.ajax_url,
            data: {
                action: 'save_custom_checkbox_to_session',
                direct_delivery: isChecked
            },
            success: function() {
                location.reload();
            }
        });
    });


    // Sample Request and Bulk Quote Request redirects
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        // Sample request
        if (event.detail.contactFormId == '65815') {
		    location.href = 'https://innotechdigital.com/sr-thank-you/';
        }
        else if (event.detail.contactFormId == '127656') {
		    location.href = 'https://innotechdigital.com/fr/sr-thank-you/';
        }
        // Bulk quote request
        else if (event.detail.contactFormId == '65814') {
		    location.href = 'https://innotechdigital.com/bqr-thank-you/';
        }
        else if (event.detail.contactFormId == '127639') {
		    location.href = 'https://innotechdigital.com/fr/bqr-thank-you/';
        }
	}, false );


	// Order text search
	jQuery('.order_search').on('input', function() {
		var text = jQuery(this).val();
		var search = text.toString().toLowerCase();

		jQuery(this).closest('.orders_row').find('.orders_slider__order').each( function() {
			var orderno = jQuery(this).data('order-no');
			var orderref = jQuery(this).data('reference');

			var ordernolwr = orderno.toString().toLowerCase();
			var orderreflwr = orderref.toString().toLowerCase();

			if(ordernolwr.includes(search) || orderreflwr.includes(search)) {
				jQuery(this).removeClass('search_hide');
			} else {
				jQuery(this).addClass('search_hide');
			}
		});
	});
	jQuery('.orders_row__btn--date').click( function() {
		jQuery(this).closest('.orders_row').find('.orders_row__date_pickers').slideToggle();
	});
	jQuery('.clear_dates').click( function() {
		jQuery(this).closest('.orders_row').find('.orders_slider__order').each( function() {
			jQuery(this).removeClass('date_hide');
		});
		jQuery(this).closest('.orders_row__date_pickers').find('input').each( function() {
			jQuery(this).val('');
		});
	});
	const start = datepicker('.all_orders_date_start', {
		id: 1,
		onSelect: (instance, date) => {
			if(jQuery('input.all_orders_date_end').val()) {
				order_date_range('all_orders', date, jQuery('input.all_orders_date_end').val());
			}
		}
	});
	const end = datepicker('.all_orders_date_end', {
		id: 1,
		onSelect: (instance, date) => {
			if(jQuery('input.all_orders_date_start').val()) {
				order_date_range('all_orders', jQuery('input.all_orders_date_start').val(), date);
			}
		}
	});
	const past_orders_start = datepicker('.past_orders_date_start', {
		id: 2,
		onSelect: (instance, date) => {
			if(jQuery('input.past_orders_date_end').val()) {
				order_date_range('past_orders', date, jQuery('input.past_orders_date_end').val());
			}
		}
	});
	const past_orders_end = datepicker('.past_orders_date_end', {
		id: 2,
		onSelect: (instance, date) => {
			if(jQuery('input.past_orders_date_start').val()) {
				order_date_range('past_orders', jQuery('input.past_orders_date_start').val(), date);
			}
		}
	});
	function order_date_range(section, start_date, end_date) {
		var start_time = Date.parse(start_date);
		var end_time = Date.parse(end_date);

		jQuery('#'+section+' .orders_slider__order').each( function() {
			var date = jQuery(this).data('datetime');

			if(date >= start_time && date <= end_time) {
				jQuery(this).removeClass('date_hide');
			} else {
				jQuery(this).addClass('date_hide');
			}
		});
	}

});


if (jQuery('body').hasClass('woocommerce-edit-account')){
	var password = document.getElementById("password_1");
  	var confirm_password = document.getElementById("password_2");

	function validatePassword(){
	if(password.value != confirm_password.value) {
		confirm_password.setCustomValidity("Passwords Don't Match");
	} else {
		confirm_password.setCustomValidity('');
	}
	}

	password.onchange = validatePassword;
	confirm_password.onkeyup = validatePassword;
}